import { render, staticRenderFns } from "./ForumThumbnailGroup.vue?vue&type=template&id=94c83c88&"
import script from "./ForumThumbnailGroup.vue?vue&type=script&lang=js&"
export * from "./ForumThumbnailGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports